module.exports = __webpack_public_path__ + "static/img/speaker-hospital.be8f1f81.png";